<template>
    <v-modal
        title="Add fields"
        @close="handleClose"
        size="large"
        v-show="isVisible">
        <div slot="contents">
            <div class="modal-content">
                <p class="stack-m">Select the fields you want to include in your export.</p>
                <div class="grid-content">
                    <div class="grid-item grid-item-full">
                        <r-input
                            v-model="searchValue"
                            label="Search fields"/>
                    </div>
                </div>
            </div>
            <div class="modal-content is-scrollable">
                <ol class="list list-group list-divided"
                    v-for="(field, index) in fieldsList">
                    <li class="list-item cursor-pointer stack-m">
                        <v-checkbox
                            :key="`${field.value}-${index}`"
                            :value="true"
                            :selected="field.selected"
                            @input="toggleField(index)">
                            <v-separated slot="label" class="display-flex align-items-center" :list="field.lineage"/>
                        </v-checkbox>
                    </li>
                </ol>
            </div>
        </div>
        <template slot="actions">
            <r-button type="primary" @click="update">Apply</r-button>
        </template>
        <template slot="left-actions">
            <r-button @click="resetFields">Revert to default</r-button>
        </template>
    </v-modal>
</template>

<script>
    import vModal from '@/components/modal/v-modal';
    import {vCheckbox} from '@/components/form';
    import vSeparated from '@/components/v-separated';

    export default {
        name: 'fields-list-modal',
        components: {
            vModal,
            vCheckbox,
            vSeparated,
        },
        props: {
            // all available resource fields
            availableFields: {
                type: Array,
                required: true,
            },
            // model fields
            fields: {
                type: Array,
                required: true,
            },
            isVisible: {
                type: Boolean,
                required: true,
            },
            defaultFields: Array,
        },
        data() {
            return {
                searchValue: '',
                initSelectedFields: [...this.fields],
                selectedFields: [...this.fields],
            };
        },
        computed: {
            fieldsList() {
                const selected = this.selectedFields;
                const selectedValues = this.selectedFields.map(field => field.value);
                const available = this.availableFields.filter(field => !selectedValues.includes(field.value));
                const fieldList = [
                    ...selected,
                    ...available,
                ].map(field => ({
                    ...field,
                    selected: selected.includes(field),
                }));

                const searchValue = this.searchValue.toLowerCase();
                return searchValue
                    ? fieldList.filter(({lineage}) => lineage.join('.').toLowerCase().includes(searchValue))
                    : fieldList;
            },
        },
        methods: {
            resetFields() {
                this.searchValue = '';
                this.selectedFields = [...this.defaultFields];
            },
            update() {
                this.$emit('update', [...this.selectedFields]);
                this.$emit('close');
            },
            toggleField(index) {
                const field = this.fieldsList[index];
                let fields = [...this.selectedFields];

                if (field.selected) {
                    fields = fields.filter(element => field.value !== element.value);
                } else {
                    fields.push(field);
                }
                this.selectedFields = fields;
            },
            handleClose() {
                this.$emit('close');
                this.$nextTick(() => {
                    this.selectedFields = [...this.fields];
                    this.initSelectedFields = [...this.fields];
                    this.searchValue = '';
                });
            },
        },
        watch: {
            fields(fields) {
                this.selectedFields = [...fields];
                this.initSelectedFields = [...fields];
            },
        },
    };
</script>
